var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourcesData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8757 43.3C52.3652 43.3 51.9508 42.8856 51.9508 42.375V12.775C51.9508 12.2663 51.5364 11.85 51.0259 11.85H8.48033C7.96979 11.85 7.55543 12.2663 7.55543 12.775V42.375C7.55543 42.8856 7.14108 43.3 6.63053 43.3C6.11998 43.3 5.70563 42.8856 5.70563 42.375V12.775C5.70563 11.2451 6.95055 10 8.48034 10H51.0259C52.5557 10 53.8006 11.2451 53.8006 12.775V42.375C53.8006 42.8856 53.3863 43.3 52.8757 43.3H52.8757Z",
    fill: "#56EE99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.875 50.6978H6.625C4.07385 50.6978 2 48.624 2 46.0728C2 45.5622 2.4144 45.1478 2.925 45.1478H23.275C23.7856 45.1478 24.2 45.5622 24.2 46.0728C24.2 46.5834 23.7856 46.9978 23.275 46.9978H4.00909C4.39019 48.0745 5.41879 48.8478 6.62499 48.8478H52.875C54.0812 48.8478 55.1098 48.0745 55.4909 46.9978H36.225C35.7144 46.9978 35.3 46.5834 35.3 46.0728C35.3 45.5622 35.7144 45.1478 36.225 45.1478H56.575C57.0856 45.1478 57.5 45.5622 57.5 46.0728C57.5 48.624 55.4261 50.6978 52.875 50.6978Z",
    fill: "#56EE99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4235 36.4504C21.2071 36.4504 20.9908 36.3746 20.8151 36.2211L13.4178 29.7475C13.2162 29.5718 13.1016 29.3202 13.1016 29.052C13.1016 28.7838 13.2162 28.5323 13.4178 28.3566L20.8151 21.883C21.1979 21.5445 21.7804 21.5815 22.1207 21.9699C22.4573 22.3546 22.4184 22.9373 22.0338 23.2739L15.4299 29.052L22.0319 34.8302C22.4166 35.1668 22.4554 35.7494 22.1188 36.1341C21.9357 36.3431 21.6805 36.4504 21.4235 36.4504L21.4235 36.4504Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9738 38.3054C26.8775 38.3054 26.7794 38.2906 26.6813 38.2591C26.1964 38.0963 25.9354 37.5725 26.0964 37.0877L31.6493 20.4324C31.8103 19.9476 32.3305 19.6829 32.8191 19.8476C33.3041 20.0105 33.5651 20.5342 33.404 21.0191L27.8511 37.6743C27.7216 38.0593 27.3606 38.3054 26.9738 38.3054Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0731 36.4503C37.8159 36.4503 37.5605 36.3431 37.3773 36.1341C37.0406 35.7494 37.0794 35.1668 37.4643 34.8302L44.0704 29.0523L37.4643 23.2745C37.0794 22.9379 37.0406 22.3553 37.3773 21.9706C37.7141 21.5822 38.2989 21.547 38.6838 21.8836L46.0856 28.3569C46.2854 28.5326 46.4001 28.7841 46.4001 29.0523C46.4001 29.3205 46.2854 29.572 46.0837 29.7477L38.6819 36.221C38.5061 36.3745 38.2896 36.4503 38.0731 36.4503H38.0731Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesData);
export default __webpack_public_path__ + "static/media/ResourcesData.51a4f9afdce93ddd9cb68e84b55e3751.svg";
export { ForwardRef as ReactComponent };